/**
 * @generated SignedSource<<91c67cec7bf869fe58af62f59d485ccc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetQuoteBrandingDefaultInput = {
  accentColor?: string | null;
  font?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type setQuoteBrandingDefaultMutation$variables = {
  input: SetQuoteBrandingDefaultInput;
};
export type setQuoteBrandingDefaultMutation$data = {
  readonly setQuoteBrandingDefault: {
    readonly company: {
      readonly id: string;
      readonly quoteBrandingDefault: {
        readonly accentColor: string | null;
        readonly font: string | null;
      } | null;
    } | null;
  } | null;
};
export type setQuoteBrandingDefaultMutation = {
  variables: setQuoteBrandingDefaultMutation$variables;
  response: setQuoteBrandingDefaultMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetQuoteBrandingDefaultPayload",
    "kind": "LinkedField",
    "name": "setQuoteBrandingDefault",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuoteBrandingDefault",
            "kind": "LinkedField",
            "name": "quoteBrandingDefault",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accentColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "font",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setQuoteBrandingDefaultMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setQuoteBrandingDefaultMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ef2cb4091f6a36017bd48c5e048132ea",
    "id": null,
    "metadata": {},
    "name": "setQuoteBrandingDefaultMutation",
    "operationKind": "mutation",
    "text": "mutation setQuoteBrandingDefaultMutation(\n  $input: SetQuoteBrandingDefaultInput!\n) {\n  setQuoteBrandingDefault(input: $input) {\n    company {\n      id\n      quoteBrandingDefault {\n        accentColor\n        font\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b8b4426dec985b4bfa9548141c1c46f";

export default node;
